import { useTranslation } from 'react-i18next';
import React from "react";
import { MdDownload } from "react-icons/md";
import { csvFilename, downloadBlob } from 'config/csv';
import axiosInstance from 'config/axiosInstance';
import { ClientSelection } from 'components/Client/Utility/selection';
import { exportCsvUrl } from 'components/Client/Utility/summary';

interface ExportCSVProps {
    showClientHour: boolean;
    dateRange: { start: string, end: string };
    /** ADM-12。一覧・グラフと同じ作業・配送先の選択。 */
    selection?: ClientSelection;
}

const NO_SELECTION: ClientSelection = { taskId: null, clientIds: [] };

/** EV-493。サーバーが返す CSV の件数（ファイル名に入れる。CORS で読めるようにしてある）。 */
const ROWS_HEADER = 'x-csv-rows';

const ExportCSV: React.FC<ExportCSVProps> = ({ showClientHour, dateRange, selection = NO_SELECTION }) => {
    const { t } = useTranslation('client');

    /**
     * EV-493。CSV はサーバー（/v1/client_deliveries/export_csv/）が作る。以前は作業記録と配送先を全件
     * （100件ずつ最大50回）取ってきて、ここで作っていた。本文（列・並び・引用・数式の無効化・CRLF・BOM・
     * 業務時間帯の日付と時刻・UTC との差・小数の時間）は以前と同じ（services/backend/api/client_analysis_csv.py。
     * 直す前の CSV と1バイトずつ比べる試験がある）。グラフ（集計 API）と同じ作業記録・同じ期間・同じ選択（ADM-12・
     * ADM-21-AC2）。
     */
    const handleExportCSV = async () => {
        try {
            const now = new Date();
            const view = showClientHour ? 'tasks' : 'clients';
            const response = await axiosInstance.get<Blob>(exportCsvUrl(view, selection, dateRange), {
                responseType: 'blob',
            });
            const rows = Number(response.headers?.[ROWS_HEADER]);
            // 件数が読めないときは、件数の違うファイル名で保存しない。
            if (!Number.isInteger(rows) || rows < 0) throw new Error(`no ${ROWS_HEADER} header`);
            // ADM-11-AC2。出力した条件・件数・作成日時をファイル名に入れる（以前と同じ付け方）。
            const filename = csvFilename('client_analysis', [
                ['period', `${dateRange.start}_${dateRange.end}`],
                ['view', view],
                ['task', selection.taskId],
                ['clients', selection.clientIds.join('-')],
            ], rows, now);
            downloadBlob(filename, response.data);
        } catch (error) {
            console.error("Failed to export CSV", error);
        }
    };
    return (
        <button
            type="button"
            className="flex rounded-md bg-white text-primary/300 font-medium p-2 justify-center items-center gap-2"
            onClick={handleExportCSV}
        >
            <span className="text-subtitle-2">{t('export_csv')}</span>
            <MdDownload size={20} aria-hidden="true" />
        </button>
    );
};

export default ExportCSV;
